import api from "./api";
import * as actionTypes from "./actionTypes";
import { sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import * as eventTypes from "./eventTypes";

export function updateOfferHeader(offerHeader, callback = () => { }) {
  return async dispatch => {
    try {
      dispatch({ type: actionTypes.UPDATE_OFFER_HEADER_STARTED, payload: { offerHeader } });
      dispatch(
        sendHttpCommandAndWaitForEvent(api.updateOfferHeader(offerHeader), "RunningOfferCommand", [
          eventTypes.OFFER_HEADER_UPDATED
        ])
      )
        .then(event => {
          if (event.ok) {
            dispatch({ type: actionTypes.UPDATE_OFFER_HEADER_SUCCESS, payload: { offerHeader } });
            callback();
          } else {
            dispatch({ type: actionTypes.UPDATE_OFFER_HEADER_FAILED, payload: { offerHeader, error: event } });
          }
        })
        .catch(error => {
          dispatch({ type: actionTypes.UPDATE_OFFER_HEADER_FAILED, payload: { offerHeader, error } });
          dispatch(showError(error.message, error.correlationId));
        });
    } catch (error) {
      dispatch({ type: actionTypes.UPDATE_OFFER_HEADER_FAILED, payload: { offerHeader, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
